import qs from 'qs'
import axios from '../index'

/**
 * @description 退货列表
 * http://192.168.2.177:3000/project/11/interface/api/925
 * @author lentoo
 * @date 2019-03-20
 * @export
 */
export function getReturnList (params) {
  return axios.post('/refund/return', qs.stringify(params))
}

/**
 * @description 退货详情
 * http://192.168.2.177:3000/project/19/interface/api/1053
 * @author lentoo
 * @date 2019-03-20
 * @export
 * @param {*} params
 * @returns
 */
export function getReturnDetail (params) {
  return axios.post('/refund/return-info', qs.stringify(params), {
    headers: {
      loading: true
    }
  })
}

/**
 * @description 关闭退货申请
 * http://192.168.2.177:3000/project/11/interface/api/941
 * @author lentoo
 * @date 2019-04-01
 * @export
 * @param {*} params
 */
export function offReturn (params) {
  return axios.post('/refund/off-return', qs.stringify(params))
}

/**
 * @description 删除退货申请
 * http://192.168.2.177:3000/project/19/interface/api/1029
 * @author lentoo
 * @date 2019-03-20
 * @export
 */
export function delReturn (params) {
  return axios.post('/refund/delete-return', qs.stringify(params))
}

/**
 * @description 提交页数据
 * http://192.168.2.177:3000/project/11/interface/api/869
 * @author lentoo
 * @date 2019-04-01
 * @export
 * @param {*} params
 * @returns
 */
export function getSubmitInfo (params) {
  return axios.post('/refund/get-submit-info', qs.stringify(params), {
    headers: {
      loading: true
    }
  })
}

/**
 * @description 提交退货
 * http://192.168.2.177:3000/project/11/interface/api/885
 * @author lentoo
 * @date 2019-04-01
 * @export
 * @param {*} params
 * @returns
 */
export function submitReturn (params) {
  return axios.post('/refund/submit-return', qs.stringify(params))
}

/**
 * @description 发货单列表
 * http://192.168.2.177:3000/project/11/interface/api/845
 * @author lentoo
 * @date 2019-03-20
 * @export
 * @param {*} params
 * @returns
 */
export function getOutBoundList (params) {
  return axios.post('/order/orders-outbound', qs.stringify(params))
}
/**
 * @description 发货单详情
 * http://192.168.2.177:3000/project/11/interface/api/861
 * @author lentoo
 * @date 2019-03-20
 * @export
 * @param {*} params
 * @returns
 */
export function getOutBoundDetail (params) {
  return axios.post('/order/outbound-info', qs.stringify(params))
}

/**
 * @description 订单详情
 * http://192.168.2.177:3000/project/19/interface/api/989
 * @author lentoo
 * @date 2019-03-20
 * @export
 * @param {*} params
 * @returns
 */
export function getOrderDetail (params) {
  return axios.post('/order/order-detail-json', qs.stringify(params), {
    headers: {
      loading: true
    }
  })
}

/**
 * @description 退款列表
 * http://192.168.2.177:3000/mock/11/refund/refund
 * @author lentoo
 * @date 2019-03-20
 * @export
 * @param {*} params
 * @returns
 */
export function getRefundList (params) {
  return axios.post('/refund/refund', qs.stringify(params))
}

/**
 * @description 删除退款申请
 * http://192.168.2.177:3000/project/11/interface/api/909
 * @author lentoo
 * @date 2019-03-20
 * @export
 * @param {*} params
 * @returns
 */
export function delRefund (params) {
  return axios.post('/refund/delete-refund', qs.stringify(params))
}

/**
 * @description 退款信息
 * @author lentoo
 * @date 2019-03-22
 * @export
 * @param {*} params
 * @returns
 */
export function getRefundInfo (params) {
  return axios.post('/refund/refund-info', qs.stringify(params), {
    headers: {
      loading: true
    }
  })
}

/**
 * @description 关闭退款申请
 * @author lentoo
 * @date 2019-04-02
 * @export
 * @param {*} params
 * @returns
 */
export function offRefund (params) {
  return axios.post('/refund/off-refund', qs.stringify(params))
}

/**
 * @description 提交退款
 * http://192.168.2.177:3000/project/11/interface/api/877
 * @author lentoo
 * @date 2019-04-02
 * @export
 * @param {*} params
 * @returns
 */
export function submitRefund (params) {
  return axios.post('/refund/submit-refund', qs.stringify(params))
}
